import { useSearchParams } from 'react-router-dom'
import { QRMBucketSlice } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer'

import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useMyDispatch } from 'featureSliced/shared/hooks/useMyDispatch'
import { useOpenModal } from 'featureSliced/shared/hooks/useOpenModal'

import { ReceiptModal } from 'components/ReceiptModal'
import { Card } from 'featureSliced/features/Profile/Card'
import { clickCollectPOST } from '../api/clickCollect/POST'

export type useCompleteAdyenType = () => void

export const useCompleteAdyen = (): useCompleteAdyenType => {
  // Hooks
  const dispatch = useMyDispatch()
  const openModal = useOpenModal()
  const [searchParams, setSearchParams] = useSearchParams()

  // Store
  const isAppInit = useMySelector((state) => state.app.isAppInit)
  const clearBucket = QRMBucketSlice.actions.clearBucket

  // Variables
  const pKey = searchParams.get('pKey')
  const show_card = searchParams.get('show_card')
  const redirectResult = searchParams.get('redirectResult')
  const show_payment_variant = searchParams.get('show_payment_variant')

  // Functions
  const completeAdyen = async () => {
    try {
      if (isAppInit && pKey) {
        if (isAppInit && pKey) {
          const isDefaultPayment = !show_card && !show_payment_variant
          const isCCUpdate = !show_card && show_payment_variant
          const isLoyaltyRefill = show_card && !show_payment_variant
          if (isDefaultPayment) {
            openReceiptModal()
          }
          if (isCCUpdate) {
            // TODO: reenable CC update confirmations. check datatrans confirmations
            // completeCreditCardUpdate()
          }
          if (isLoyaltyRefill) {
            completeCardRefill()
          }
        }
      }
    } catch (e) {
      searchParams.delete('pKey')
      searchParams.delete('show_card')
      searchParams.delete('redirectResult')
      searchParams.delete('show_payment_variant')
      setSearchParams(searchParams)
    }
  }

  const completeCardRefill = async () => {
    const success = await clickCollectPOST.refillCardComplete(
      pKey,
      null,
      redirectResult
    )
    if (success) {
      openModal({
        id: 'USER_CARD',
        title: '',
        components: [() => <Card customDelay={2000} />],
      })
    }
    searchParams.delete('pKey')
    searchParams.delete('show_card')
    searchParams.delete('redirectResult')
    setSearchParams(searchParams)
  }

  const openReceiptModal = async () => {
    openModal({
      id: 'RECEIPT_MODAL',
      // title: t('order.toMenu'),
      // onClose: handleReceiptModalClose,
      shouldHideCross: true,
      components: [
        ({ closeThisModal }) => (
          <ReceiptModal
            paymentKey={pKey}
            onCloseModal={(orderGuid?: string) => {
              closeThisModal()
              handleReceiptModalClose(orderGuid)
            }}
          />
        ),
      ],
    })
  }

  const handleReceiptModalClose = (orderGuid?: string) => {
    searchParams.delete('pKey')
    searchParams.delete('redirectResult')
    if (orderGuid) {
      searchParams.delete('table')
    }
    setSearchParams(searchParams)
    clearLocalStorage()
    dispatch(clearBucket())
  }

  const clearLocalStorage = () => {
    window.localStorage.removeItem('products_notes')
  }

  return completeAdyen
}
